import { createContext, useContext, useState } from 'react';
import { useSelector } from 'react-redux';

import { sendFeedback, prepareUserName } from '../services/feedbackService';
import { redirectAndReloadPage } from '../services/sentryReport';

const CrashReportContext = createContext();

export const CrashReportProvider = ({ children }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [crashData, setCrashData] = useState(null);

  const { user } = useSelector((state) => state.user);

  const LEVEL_CRITICAL = 'critical'

  const openCrashReport = (errorData = null) => {
    setCrashData(errorData);
    setIsModalOpen(true);
    setShowSuccess(false);
  };

  const closeCrashReport = () => {
    setIsModalOpen(false);
    setShowSuccess(false);
    setCrashData(null);
  };

  const showSuccessScreen = () => {
    setShowSuccess(true);
  };

  const resumeFromSuccess = () => {
    setShowSuccess(false);
    setIsModalOpen(false);
    setCrashData(null);
    redirectAndReloadPage();
  };

  const submitCrashReport = async (reportData) => {
    try {
      console.info('Rapport de crash soumis:', {
        ...reportData,
        crashData,
        timestamp: new Date().toISOString(),
        userAgent: navigator.userAgent,
        url: window.location.href
      });

      const userName = prepareUserName(user, reportData?.email);
      const dataFeedback = {
        name: userName,
        email: reportData.email,
        message: reportData.description,
        level: "error"
      }

      await sendFeedback(dataFeedback, LEVEL_CRITICAL);
      showSuccessScreen();

      return { success: true };
    } catch (error) {
      console.error('Erreur lors de l\'envoi du rapport:', error);
      throw error;
    }
  };

  const value = {
    isModalOpen,
    showSuccess,
    crashData,
    openCrashReport,
    closeCrashReport,
    showSuccessScreen,
    resumeFromSuccess,
    submitCrashReport
  };

  return (
    <CrashReportContext.Provider value={value}>
      {children}
    </CrashReportContext.Provider>
  );
};

export const useCrashReport = () => {
  const context = useContext(CrashReportContext);

  if (!context) {
    throw new Error('useCrashReport should be used in CrashReportProvider');
  }

  return context;
};

export default CrashReportContext;